export type DaycareBookingsView = 'kanban' | 'list';

const STORAGE_KEY = 'daycareBookingsView';

export const readDaycareBookingsView = (): DaycareBookingsView => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'kanban';
    } catch {
        return 'kanban';
    }
};

export const saveDaycareBookingsView = (view: DaycareBookingsView) => {
    try {
        localStorage.setItem(STORAGE_KEY, view);
    } catch {
        // The preference remains in memory when browser storage is unavailable.
    }
};
